import Swiper from 'swiper/dist/js/swiper.min';
import Vue from 'vue';
import Form from '../form/form';

export default function () {
  const about = document.querySelector('.about');

  if (about) {
    const excursion = about.querySelector('.about__excursion');

    if (excursion && !excursion.querySelector('.experts-slider')) {
      new Vue({
        el: excursion,
        delimiters: ['${', '}}'],
        props: ['experts'],
        data: {
          info: window.formsData.excursion.experts,
          loopIndex: 0,
          expert: {
            name: '',
            img: '',
            job: '',
          },
        },
        methods: {
          loopForever(array) {
            this.loop = setInterval(() => {
              this.changeExpert(array[this.loopIndex].id);
              this.loopIndex += 1;

              if (this.loopIndex === array.length) this.loopIndex = 0;
            }, 2000);
          },
          stopLoop() {
            if (this.loop) clearInterval(this.loop);
          },
          changeExpert(id, change = true) {
            let expert;
            if (change) {
              expert = this.info.list.find(el => el.id === id);
            } else {
              expert = this.info.list.find(el => el.checked);
            }

            this.expert.name = expert.name;
            this.expert.job = expert.job;
            this.expert.img = `url(${expert.img})`;
          },
        },
        components: {
          aboutForm: Form(window.formsData.excursion.form),
        },
        mounted() {
          if (this.info && !excursion.querySelector('.experts-slider')) {
            this.changeExpert('', false);
            this.loopForever(this.info.list);
          }
        },
      });
    } else if (excursion.querySelector('.experts-slider')) {
      new Vue({
        el: excursion,
        delimiters: ['${', '}}'],
        data: {
          info: window.formsData.excursion.experts,
          mainSlider: null,
          thumbsSlider: null,
          expert: {
            name: '',
          },
        },
        methods: {
          stopLoop() {
          },
          initSlider() {
            this.thumbsSlider = new Swiper(this.thumbsSlider, {
              slidesPerView: 'auto',
              spaceBetween: 8,
              slideToClickedSlide: true,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
            });

            if ([].slice.call(this.thumbsSlider.pagination.bullets).length <= 1) {
              this.thumbsSlider.pagination.el.classList.add('experts-slider__pagination--hide');
            }

            const thumbs = this.thumbsSlider;

            this.mainSlider = new Swiper(this.mainSlider, {
              slidesPerView: 1,
              autoplay: {
                delay: 5000,
                disableOnInteraction: false,
              },
              thumbs: {
                swiper: thumbs,
              },
              on: {
                init() {
                  if (thumbs !== undefined) {
                    const slidesThumb = [].slice.call(thumbs.slides);
                    slidesThumb.forEach(tmp => tmp.classList.remove('experts-slider__thumb-slide--active'));
                    if (slidesThumb.length) {
                      slidesThumb[0].classList.add('experts-slider__thumb-slide--active');
                    }
                    thumbs.slideTo(0);
                    thumbs.activeIndex = 0;
                    thumbs.clickedIndex = 0;
                  }
                },
                slideChange() {
                  if (thumbs !== undefined) {
                    const slidesThumb = [].slice.call(thumbs.slides);
                    slidesThumb.forEach(tmp => tmp.classList.remove('experts-slider__thumb-slide--active'));
                    slidesThumb[this.realIndex].classList.add('experts-slider__thumb-slide--active');
                    thumbs.slideTo(this.realIndex);
                    thumbs.activeIndex = this.realIndex;
                    thumbs.clickedIndex = this.realIndex;
                  }
                },
              },
            });

            this.mainSlider.on('slideChange', () => {
              this.expert.name = this.thumbsSlider.slides[this.thumbsSlider.realIndex].dataset.name;
              this.expert.job = this.thumbsSlider.slides[this.thumbsSlider.realIndex].dataset.job;
            });
          },
        },
        components: {
          aboutForm: Form(window.formsData.excursion.form),
        },
        mounted() {
          this.mainSlider = this.$el.querySelector('.experts-slider__main');
          this.thumbsSlider = this.$el.querySelector('.experts-slider__thumbs');
          this.initSlider();
        },
      });
    }
  }
}



// WEBPACK FOOTER //
// ./new-blocks/about/about.js